import React from 'react';
import { Link } from 'react-router-dom';

const SingleService = ({ icon, title, content, link }) => {
   return (
      <>
         <div className="tw-w-full tw-px-3 sm:tw-w-1/2 md:tw-w-1/2 lg:tw-w-1/4">
            <div className="services__item mb-90">
               <div className="services__icon mb-35">
                  <i>{icon}</i>
               </div>
               <div className="services__content">
                  <h3><Link to={link}>{title}</Link></h3>
                  <p>{content}</p>
               </div>
            </div>
         </div>
      </>
   );
};

export default SingleService;